'use client';

import clsx from 'clsx';
import type { ReactNode } from 'react';

import styles from './InlineErrorAlert.module.scss';
import WarningIcon from './warning.svg';

export interface InlineErrorAlertProps {
  children: ReactNode;
  id?: string;
  className?: string;
  'data-testid'?: string;
}

export function InlineErrorAlert({
  children,
  id,
  className,
  'data-testid': testId,
}: Readonly<InlineErrorAlertProps>) {
  return (
    <div id={id} className={clsx(styles.alert, className)} role="alert" data-testid={testId}>
      <span className={styles.icon} aria-hidden="true">
        <WarningIcon className={styles.iconGlyph} width={20} height={20} />
      </span>
      <p className={styles.message}>{children}</p>
    </div>
  );
}
